/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * Set of entity types recognized by the NER pipeline in the analyzed prompt.
 * Used to drive real-time hints to the user while typing.
 * 
 * @export
 * @interface DetectedPromptEntities
 */
export interface DetectedPromptEntities {
    /**
     * 
     * @type {boolean}
     * @memberof DetectedPromptEntities
     */
    jobTitle: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetectedPromptEntities
     */
    dailyRate: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetectedPromptEntities
     */
    industry: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetectedPromptEntities
     */
    location: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetectedPromptEntities
     */
    experience: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetectedPromptEntities
     */
    skills: boolean;
}

/**
 * Check if a given object implements the DetectedPromptEntities interface.
 */
export function instanceOfDetectedPromptEntities(value: object): value is DetectedPromptEntities {
    if (!('jobTitle' in value) || value['jobTitle'] === undefined) return false;
    if (!('dailyRate' in value) || value['dailyRate'] === undefined) return false;
    if (!('industry' in value) || value['industry'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('experience' in value) || value['experience'] === undefined) return false;
    if (!('skills' in value) || value['skills'] === undefined) return false;
    return true;
}

export function DetectedPromptEntitiesFromJSON(json: any): DetectedPromptEntities {
    return DetectedPromptEntitiesFromJSONTyped(json, false);
}

export function DetectedPromptEntitiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DetectedPromptEntities {
    if (json == null) {
        return json;
    }
    return {
        
        'jobTitle': json['jobTitle'],
        'dailyRate': json['dailyRate'],
        'industry': json['industry'],
        'location': json['location'],
        'experience': json['experience'],
        'skills': json['skills'],
    };
}

export function DetectedPromptEntitiesToJSON(value?: DetectedPromptEntities | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'jobTitle': value['jobTitle'],
        'dailyRate': value['dailyRate'],
        'industry': value['industry'],
        'location': value['location'],
        'experience': value['experience'],
        'skills': value['skills'],
    };
}

